import { FC } from 'react';
import lodash from 'lodash';
import { useSnackbar } from 'notistack';
import Filters from '../..';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { useActions } from 'src/hooks/useActions';
import './styles.scss';
import './media.scss';

interface IProps {
  type: 'main' | 'sec';
}

const LocationsFilter: FC<IProps> = ({ type }) => {
  const { setLocationFilter, setEndLocationFilter } = useActions();
  const { enqueueSnackbar } = useSnackbar();
  const {
    van: { checkFilter },
    oneway: { onewayList }
  } = useTypedSelector(state => state);

  const setStartLocation = (start: string, end: string | undefined) => {
    if (end) {
      const oneway = lodash.find(onewayList, {
        start_location: start,
        end_location: end
      });
      if (oneway) setLocationFilter(start, '');
      else enqueueSnackbar('Not available yet', { variant: 'info' });
    } else setLocationFilter(start, '');
  };

  const setEndLocation = (start: string | undefined, end: string) => {
    if (!start && end) enqueueSnackbar('Please select a start location', { variant: 'info' });
    else {
      const oneway = lodash.find(onewayList, {
        start_location: start,
        end_location: end
      });
      if (oneway) setEndLocationFilter(end);
      else if (start !== end) enqueueSnackbar('Not available yet', { variant: 'info' });
      else setEndLocationFilter('');
    }
  };

  return (
    <div className={`locations-filter__${type}`}>
      <Filters.Location
        check={checkFilter}
        className={`locations-filter__location-${type}`}
        setLocation={setStartLocation}
      />
      <Filters.AnotherLocation
        check={checkFilter}
        className={`locations-filter__location-${type}`}
        setLocation={setEndLocation}
      />
    </div>
  );
};

export default LocationsFilter;
